import { ChevronDown } from "lucide-react";
import heroImage from "/public/hero-cinematographer.jpg";

const FoundersHeroSection = () => {
    const scrollToPortfolio = () => {
        document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${heroImage})` }}
            />

            {/* Overlay */}
            <div className="absolute inset-0 overlay-gradient" />

            {/* Content */}
            <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
                <div className="fade-in-up">
                    <h1 className="hero-text mb-6">
                       Samson Ojo
                    </h1>
                    <p className="subheading-text mb-4 text-primary-foreground/90">
                        Creative Director / Cinematographer
                    </p>
                    <p className="text-lg mb-12 text-primary-foreground/80 max-w-2xl mx-auto leading-relaxed">
                        Crafting visual stories that transcend the ordinary.
                        Where emotion meets artistry, and every frame tells a story worth remembering.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                        {/* Normal Styled Button for "View My Work" */}
                        <button
                            onClick={scrollToPortfolio}
                            className="accent-gradient text-primary-foreground hover:scale-105 shadow-glow border-none px-8 py-4 text-base font-medium"
                        >
                            View My Work
                        </button>

                        {/* Normal Styled Button for "Get In Touch" */}
                        {/* <button
                            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                            className="bg-transparent border-2 border-white text-white py-3 px-8 text-lg font-semibold shadow-md hover:bg-white hover:text-orange-400 transition-colors ease-in-out duration-300"
                        >
                            Get In Touch
                        </button> */}
                    </div>
                </div>
            </div>

            {/* Scroll Indicator */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce">
                <ChevronDown size={32} />
            </div>
        </section>
    );
};

export default FoundersHeroSection;
